import { NoteType } from '../../../../../../../app/types/order-notes'

export function getOrderNotes(orderObjectId: string, type?: string) {
  let url = `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/notes`
  if (type) {
    url += `?type=${type}`
  }
  return {
    method: 'GET',
    url,
  }
}

export function createOrderNote(
  orderObjectId: string,
  type: NoteType,
  content: string,
  createdBy: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/notes`,
    body: {
      type,
      content,
      createdBy,
    },
  }
}
